import { Component } from '@angular/core';
import { TimetrackSelectors, TimetrackDispatchers } from '@store';
import { TimetrackDescription, KrKladde, UgerepDone } from '@store/models';

@Component({
    selector: 'app-money-log',
    template: `
        <app-money-log-ui
        [user]="user$ | async"
            [year]="year$ | async"
            [week]="week$ | async"
            [today]="today$ | async"
            [kronekladde]="kronekladde$ | async"
            [weekTotals]="weekTotals$ | async"
            [ugerepDoneWeek]="ugerepDoneWeek$ | async"
            (saveKr)="saveKr($event)"
            (saveBeskrivelse)="saveBeskrivelse($event)"
            (doneDay)="doneDay($event)"
        ></app-money-log-ui>
  `,
    standalone: false
})
export class MoneyLogContainerComponent {

    user$ = this.timetrackSelector.user$;
    year$ = this.timetrackSelector.year$;
    week$ = this.timetrackSelector.week$;
    today$ = this.timetrackSelector.today$;
    weekTotals$ = this.timetrackSelector.weekAmountTotals$;
    kronekladde$ = this.timetrackSelector.kronekladde$;
    ugerepDoneWeek$ = this.timetrackSelector.ugerepDoneWeek$;

    constructor(
        private timetrackSelector: TimetrackSelectors,
        private timetrackDispatch: TimetrackDispatchers
    ) {}

    saveKr(partialKrKladde: Partial<KrKladde>) {
        this.timetrackDispatch.createKrKladde(partialKrKladde);
    }

    saveBeskrivelse(timetrackDescription: TimetrackDescription) {
        this.timetrackDispatch.updateKrKladdeBeskrivelse(timetrackDescription);
    }

    doneDay(ugerepDone: UgerepDone) {
        this.timetrackDispatch.createUgerepDone(ugerepDone);
    }

}
